import Locale from "./Locale"

/** Speed Increment Labels with associated enum */
export function getIncrementNames() { return {
    STOPPED: Locale.gettext('Stopped'),
    FORWARD_SLOW: Locale.gettext('Slow'),
    FORWARD_MED_SLOW: Locale.gettext('Slow-Med'),
    FORWARD_MEDIUM: Locale.gettext('Medium'),
    FORWARD_MED_FAST: Locale.gettext('Med-Fast'),
    FORWARD_FAST: Locale.gettext('Fast'),
    REVERSE_SLOW: Locale.gettext('Slow Reverse'),
    REVERSE_MED_SLOW: Locale.gettext('Slow-Med Reverse'),
    REVERSE_MEDIUM: Locale.gettext('Medium Reverse'),
    REVERSE_MED_FAST: Locale.gettext('Med-Fast Reverse'),
    REVERSE_FAST: Locale.gettext('Fast Reverse')
} }

/** Some of these, while helpful to us at poolside, are not very helpful for end-users
 *  and we should simply use 'Local' for all events that the attendant and/or cloud is doing
 *  automatically.
 */
export function getSetByStateTexts() { return {
    LOCAL_UI: Locale.gettext("Local (UI)"),
    FREEZE_PROTECT: Locale.gettext("Freeze Protect"),
    SCHEDULE: Locale.gettext("Schedule"),
    MONITOR: Locale.gettext('Local (Monitor)'),
    READYBY_SCHEDULE: Locale.gettext('Ready-By Schedule'),
    API: Locale.gettext('Local (API)'),
    BUTTON : Locale.gettext('Remote/Button'),
    UNKNOWN: Locale.gettext('Local')
} }
